const projects = [
  {
    link: "/projects/simonrosesoftware",
    image: "simonrosesoftware.jpg",
    title: "Simon Rose Software",
    desc: "Static Nuxt.js website to advertise my freelance software business.",
    lang: "Nuxt.js, JavaScript, Firebase",
    year: "2021",
  },
  {
    link: "/projects/cognitivefunctiontask/",
    image: "cft.jpg",
    title: "CFT",
    desc:
      "Web-based game and content management system to assess cognitive function.",
    lang: "Vue.js, JavaScript, Node.js, MongoDB",
    year: "2020",
  },
  {
    link: "/projects/pirateplunder/",
    image: "pirateplunder.jpg",
    title: "Pirate Plunder",
    desc: "Programming game to teach abstraction skills using Scratch blocks.",
    lang: "AngularJS, TypeScript, Node.js, MongoDB",
    year: "2019",
  },
  {
    link: "/projects/revealvr/",
    image: "revealvr.jpg",
    title: "REVEAL",
    desc: "Website created in Wordpress using the Avada template.",
    lang: "Wordpress, HTML, CSS",
    year: "2018",
  },
  {
    link: "/projects/sequencer/",
    image: "sequencer.jpg",
    title: "Sequencer",
    desc:
      "Quiz application to measure the sequencing ability of young children.",
    lang: "AngularJS, TypeScript, Node.js, MongoDB",
    year: "2017",
  },
  {
    link: "/projects/archivedesignstudio/",
    image: "archive.jpg",
    title: "Archive Design Studio",
    desc: "Website written in HTML and AngularJS.",
    lang: "AngularJS, JavaScript, PHP, HTML",
    year: "2016",
  },
  {
    link: "/projects/portfolio/",
    image: "portfolio.jpg",
    title: "Portfolio",
    desc: "Static portfolio written in React and using Gatsby.js.",
    lang: "React, JavaScript",
    year: "2016",
  },
  {
    link: "/projects/speakeasy/",
    image: "speakeasy.jpg",
    title: "Speakeasy",
    desc: "Speach generating application for a child with cerebral palsy.",
    lang: "AngularJS, JavaScript, Node.js, MongoDB",
    year: "2016",
  },
  {
    link: "/projects/dimbot/",
    image: "dimbot.jpg",
    title: "Dimbot",
    desc:
      "A game based on Lightbot, used to test visual programming environments.",
    lang: "AngularJS, JavaScript, Node.js, MongoDB",
    year: "2015",
  },
  {
    link: "/projects/tester/",
    image: "tester.jpg",
    title: "Tester",
    desc: "A quiz application used to test non-verbal reasoning ability.",
    lang: "AngularJS, JavaScript, Node.js, MongoDB",
    year: "2015",
  },
  {
    link: "/projects/slidinghome/",
    image: "slidinghome.jpg",
    title: "Sliding Home",
    desc: "Mobile game developed using the Marmalade SDK.",
    lang: "C++, Marmalade",
    year: "2015",
  },
  {
    link: "/projects/mincemeat/",
    image: "mincemeat.jpg",
    title: "Mincemeat",
    desc: "Lemmings-based game developed in GameMaker.",
    lang: "GML",
    year: "2013",
  },
]

export default projects
